import { ElementType } from 'react';
import { Size } from '@optimus-web/common';
import { TypographyComponentProps } from '../../types';
import { Typography } from '../../Typography';

type HighlightSize = Exclude<Size, 'extraLarge'>;
export type HighlightProps = Omit<TypographyComponentProps, 'as'> & { size?: HighlightSize; as?: ElementType };

const getHighlightSize = (highlightSize: HighlightSize) => {
    switch (highlightSize) {
        case 'small':
            return 'bodyLargeStrong';
        case 'medium':
            return 'highlightSmall';
        case 'large':
            return 'highlightMedium';
    }
};

export const Highlight = ({ as, size = 'medium', ...props }: HighlightProps) => (
    <Typography {...props} textStyle={getHighlightSize(size)} as={as || 'strong'} />
);
